import * as React from 'react'
import { FC } from 'react'

import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Popover from '@mui/material/Popover'

import { EditPencilIcon } from '@sales-center/components'
import { ENTITY_TYPES } from '@sales-center/common'
import { ILeadDetail } from '@user/store/lead/typings'
import { IOpportunityDetail } from '@user/store/opportunity/typings'
import { EditPencilContent } from './EditPencilContent'

type LeadProps = {
  detail: ILeadDetail
  entityType: ENTITY_TYPES.Lead
}

type OpportunityProps = {
  detail: IOpportunityDetail
  entityType: ENTITY_TYPES.Opportunity
}

export type EditPencilProps = LeadProps | OpportunityProps

export const EditPencil: FC<EditPencilProps> = (props) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) =>
      setAnchorEl(event.currentTarget),
    [],
  )

  const handleClose = React.useCallback(() => setAnchorEl(null), [])

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  return (
    <Box display="inline">
      <IconButton
        data-testid={`edit-btn-${props.detail.id}`}
        aria-describedby={id}
        onClick={handleClick}
        size="small"
      >
        <EditPencilIcon />
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <EditPencilContent {...props} onClose={handleClose} />
      </Popover>
    </Box>
  )
}

EditPencil.displayName = 'EditPencil'
